import { setAccountRestriction } from "../Redux/store/accountRestrictionSlice";

const DEFAULT_RESTRICTION_MESSAGE =
  "Your account is restricted. Please contact support.";

export const getRestrictionFields = (data) => {
  if (!data || typeof data !== "object") {
    return { isRestricted: false, restrictionReason: "" };
  }

  const nested = data.my_profile || data.profile || {};

  return {
    isRestricted:
      Number(data.is_restricted ?? nested.is_restricted) === 1,
    restrictionReason:
      data.restriction_reason || nested.restriction_reason || "",
  };
};

export const syncAccountRestriction = (dispatch, data) => {
  const { isRestricted, restrictionReason } = getRestrictionFields(data);

  dispatch(
    setAccountRestriction({
      isRestricted,
      restrictionReason,
    })
  );

  return { isRestricted, restrictionReason };
};

export const getRestrictionDisplayMessage = (restrictionReason) =>
  restrictionReason?.trim() || DEFAULT_RESTRICTION_MESSAGE;
